/** VERSION: 0.0.3 Please do not delete this line. Thank you! **/
var sizeHandle = '';
var colFilterQuery = getQueryParams(document.location.search);
var pageLoad = false;
var gridV2 = false;

 

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var htoProductStorage = JSON.parse(localStorage.getItem("products")) == null ? [] : JSON.parse(localStorage.getItem("products")); 
var featuredImage = '';
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false,
    // Placeholder  
    showPlaceholderProductList: true,
    placeholderProductPerRow: 3,
    placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
    enableOTP: true,
    filterTreeMobileStyle: 'style2', // 'style2', 'style3',
    aspect_ratio: boostPFSThemeConfig.custom.aspect_ratio,
    cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.product_img_crop,
    defaultDisplay: boostPFSThemeConfig.custom.product_item_type,
      enableAjaxCart: true,
    ajaxCartStyle: 'slide', // 'slide' or 'popup'
    showAjaxCartOnAdd: true, // Opens the ajax cart after add to cart
    autoCloseMiniCart: false, // Auto close the cart after add to cart > open cart > close cart
    autoCloseMiniCartDuration: 2000,
    selectOptionInProductItem: true, // Append the product's option inside the product item when clicking "select option"
    selectOptionContainer: '.boost-pfs-filter-product-item-image',  // CSS selector to append the product option, if left empty it will append to the product item
    boostPFSImgDefaultSrc:  'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    //boostPFSSizes:  '(min-width: 1367px) 267px, (min-width: 991px) 267px, (min-width: 750px) 319px, (min-width: 480px) 335px, (min-width: 413px) 432px, (min-width: 361px) 365px, 313px',
    boostPFSSizes: '(min-width: 1367px) 267px, (min-width: 991px) 267px, (min-width: 750px) 319px, (min-width: 480px) 592px, (min-width: 413px) 432px, (min-width: 361px) 365px, 313px'
  },
  selector: {
    otpButtons: '.boost-pfs-filter-product-item-image'
  }
};


(function() {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    firstVariant = {},
    boostPFSImgDefaultSrc = boostPFSFilterConfig.boostPFSImgDefaultSrc,
    boostPFSRangeWidths = [267, 267, 319, 592, 432, 365, 313];
    boostPFSSizes = boostPFSFilterConfig.boostPFSSizes;
  BoostPFS.inject(this);
  boostPFSFilterConfig.general.separateRefineByFromFilter = jQ('.boost-pfs-filter-tree-h').length > 0 ? true : false;

  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  firstVariant = data['variants'][0];
  if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == Utils.getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  var originalCompileTemplate = ProductGridItem.prototype.compileTemplate;
  ProductGridItem.prototype.compileTemplate = function(data) {
    if (!data) data = this.data;
    //console.log(data.title);
    //console.log(data);
    //console.log(this.index)
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    var saleClass = onSale ? boostPFSTemplate.saleClass : '';

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
    // Add Grid Width class
    itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
    // Add TAG Label
    itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);




    // Add Review
    if (typeof Integration === 'undefined' ||
      (typeof Integration != 'undefined' &&
        typeof Integration.hascompileTemplate == 'function' &&
        !Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // itemActiveSwapClass
    itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));

    // Add Color Swatches
    itemHtml = itemHtml.replace(/{{itemSwatches}}/g, buildProductOptionSwatches(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
    itemHtml = itemHtml.replace(/{{variantId}}/g, data.variants[0].id);
    itemHtml = itemHtml.replace(/{{variantJSON}}/g, JSON.stringify(data.variants)); 
    itemHtml = itemHtml.replace(/{{itemTag}}/g, data.tags.join(', ')); 

    var lsImgCode = '';
    $.each(data.metafields, function(index,metafieldsObject){
        var key = metafieldsObject.key;
        if (key == 'lifestyle_image') {
          var metafieldValue = metafieldsObject.value;
          //console.log(data.title, metafieldsObject.value, Utils.optimizeImage(metafieldValue, '300x'));
          lsImgCode = '<div class="card-info ls-image"><div class="ls-image-box" data-handle="'+data.handle+'"></div></div>'


        } 
    });
    itemHtml = itemHtml.replace(/{{itemLS}}/g, lsImgCode); 

    
  


    //itemHtml = itemHtml.replace(/{{itemLS}}/g, lsImgCode);

    //var variantString = JSON.stringify(data.variants);
    //console.log('sssssss');
    //console.log(data.title);
    //console.log(variantString);
    //console.log(JSON.parse(variantString));
    //console.log(data.options_with_values);
    var htoSize = '';
    var hasSize = true;
    var hasHTO = true;
    var pc02b = false;
    var skipPC02B = false; 
    
    $.each(data.tags, function( key, value ) {
      if (value == theme.custom.noHTOTag) {
        hasHTO = false;  
      }
      if (value.indexOf('Sizes_') == 0) {
        pc02b = true;
      }
      if (value == 'No-PC02B') {
        skipPC02B = true;
      }
    });  
    if (data.available == false) {
      hasHTO = false;  
    }

    //console.log('pc02b:'+pc02b+'|'+data.handle);
    //console.log('hasHTO:'+hasHTO);

    if (pc02b) {
      // pc02b  size
      var filterSizesMapArr = boostPFSThemeConfig.custom.filterSizesMap.split(', ');
      var PC02BSizeTag = '';
      $.each(filterSizesMapArr, function( key, value ) {
        var filterVal = value.replace('Sizes_', '').split(': ')[0];
        var filterHandle = value.replace('Sizes_', '').split(': ')[1];    
        var sizeValue = filterVal.replace('Sizes_', '').split(' [')[0];
        var sizeTxt = sizeValue.replace('Kids', 'Youth');
        var handleVal = '';
        var eyeSize = '';
          
        $.each(data.tags, function(key, tagName) {
          //console.log('pTag:'+tagName);
          if (tagName.indexOf('Sizes_'+filterVal) > -1) {
            handleVal = '-'+filterHandle;
            //console.log('sizeValue:'+sizeValue);
            // console.log('handleVal:'+handleVal);
            $.each(data.tags, function(key, tagSize) {
              //console.log('sizeValue:'+'PC02B:'+sizeValue);
              //console.log('sizeValue:'+tagSize.indexOf('PC02B:'+sizeValue));
              if (tagSize.indexOf('PC02B:'+sizeValue) > -1) {
                var sizeSplitter = sizeValue+'_';                
                eyeSize = tagSize.split(sizeSplitter)[1];
                if (PC02BSizeTag == '') {
                  PC02BSizeTag += tagSize.replace('PC02B:', '').toLowerCase();  
                } else {
                  PC02BSizeTag += ', '+ tagSize.replace('PC02B:', '').toLowerCase();
                }
              }  

            });  
            
            htoSize += '<label data-type="pc02b" data-eye-size="'+eyeSize+'" data-size="'+sizeTxt+'" data-handle="'+handleVal+'"><input type="checkbox" value="'+sizeValue+'" name="option-'+data.handle+'" /><span>'+sizeTxt+'</span></label>'; 
          }
        });  
      });  
      

    } else {
      // normal size
      $.each(data.options_with_values, function( key, optName ) {
        var variantTitle = '';
        //console.log('optName');
        //console.log(optName);
          var eyeSize = '';
          if (optName.name == 'size') {
            $.each(optName.values, function( key, sizeVal ) {
              //console.log(sizeVal);
              var sizeText = sizeVal.title;
              var variantId = '';
              $.each(data.variants, function( key, variantEntry ) {
                  //console.log(variantEntry.option_size);  
                  if (variantEntry.title.indexOf(sizeText) > -1) { 
                    //console.log('sizeText:'+sizeText);
                    //console.log(variantEntry.id);
                    var sizeTxt = variantEntry.option_size;
                    var eyeSize = sizeText.match(/\d/g);
                    eyeSize = eyeSize.join('');

                    variantId = variantEntry.id; 
                    return false;
                  } 
              }); 
              htoSize += '<label class="normal" data-eye-size="'+sizeText.replace(/[^0-9]/g, '')+'" data-size="'+sizeText+'"><input type="checkbox" value="'+variantId+'" name="option-'+data.handle+'" /><span>'+sizeText+'</span></label>';
            }); 
          } 
      });
      
    }
    itemHtml = itemHtml.replace(/{{pc02b}}/g, pc02b); 
    if (skipPC02B == true) {
        PC02BSizeTag = '';
    }

    if (htoSize == '') {
      htoSize += '<label data-size="default"><input type="checkbox" value="'+data.variants[0].id+'" name="option-'+data.handle+'" /><span>Default Size</span></label>';
      hasSize = false;
      itemHtml = itemHtml.replace(/{{hasSize}}/g, false); 
    } else {
      itemHtml = itemHtml.replace(/{{hasSize}}/g, true); 
    }
    itemHtml = itemHtml.replace(/{{htoSize}}/g, htoSize);
    itemHtml = itemHtml.replace(/{{htoEnable}}/g, hasHTO);
    itemHtml = itemHtml.replace(/{{PC02BSizeTag}}/g, PC02BSizeTag);
    itemHtml = itemHtml.replace(/{{PC02BFlag}}/g, skipPC02B);


    
    //console.log(itemHtml);
    return itemHtml;
  };
  // Build Product List Item
  ProductListItem.prototype.compileTemplate = function(data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // For List View
    // Get Template
    var itemHtml = boostPFSTemplate.productListItemHtml;

    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    var saleClass = onSale ? boostPFSTemplate.saleClass : '';

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
    // Add TAG Label
    itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

    // Add Review
    if (typeof Integration === 'undefined' ||
      (typeof Integration != 'undefined' &&
        typeof Integration.hascompileTemplate == 'function' &&
        !Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add Price
    var itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Description
    var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    itemDescription = (itemDescription.split(" ")).length > 35 ? itemDescription.split(" ").splice(0, 35).join(" ") + '...' : itemDescription.split(" ").splice(0, 35).join(" ");
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

    // itemActiveSwapClass
    itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));

    // Add Color Swatches
    itemHtml = itemHtml.replace(/{{itemSwatches}}/g, buildProductOptionSwatches(data));

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);

    return itemHtml;
    // End For List View
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildGridWidthClass() {
    var gridWidthClass = '';
    // On PC
    switch (boostPFSThemeConfig.custom.products_per_row) {
      case 2:
        gridWidthClass = 'boost-pfs-filter-grid-width-2 ';
        break;
      case 3:
        gridWidthClass = 'boost-pfs-filter-grid-width-3 ';
        break;
      case 5:
        gridWidthClass = 'boost-pfs-filter-grid-width-5 ';
        break;
      case 6:
        gridWidthClass = 'boost-pfs-filter-grid-width-6 ';
        break;
      default:
        gridWidthClass = 'boost-pfs-filter-grid-width-4 ';
        break;
    }

    // tablet
    switch (boostPFSThemeConfig.custom.products_per_row_t) {
      case 2:
        gridWidthClass += 'boost-pfs-filter-grid-width-t-2 ';
        break;
      case 3:
        gridWidthClass += 'boost-pfs-filter-grid-width-t-3 ';
        break;
      case 4:
        gridWidthClass += 'boost-pfs-filter-grid-width-t-4 ';
        break;
      case 5:
        gridWidthClass += 'boost-pfs-filter-grid-width-t-5 ';
        break;
      case 6:
        gridWidthClass += 'boost-pfs-filter-grid-width-t-6 ';
        break;
      default:
        gridWidthClass += 'boost-pfs-filter-grid-width-t-1 ';
        break;
    }


    // On Mobile
    switch (boostPFSThemeConfig.custom.products_per_row_m) {
      case 1:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-1 ';
        break;
      case 3:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-3 ';
        break;
      default:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-2 ';
        break;
    }

    // On Mobile wide
    switch (boostPFSThemeConfig.custom.products_per_row_mw) {
      case 1:
        gridWidthClass += ' boost-pfs-filter-grid-width-mw-1 ';
        break;
      case 3:
        gridWidthClass += ' boost-pfs-filter-grid-width-mw-3 ';
        break;
      case 4:
        gridWidthClass += ' boost-pfs-filter-grid-width-mw-4 ';
        break;  
      default:
        gridWidthClass += ' boost-pfs-filter-grid-width-mw-2 ';
        break;
    }

    return gridWidthClass;
  }

  function buildImages(data) {
    var html = '',
      aspectRatio = '',
      rangeWidths = boostPFSRangeWidths,
      paddingTop = 100;

    var dataSrcSet = '',
      dataWidths = '',
      dataSizes = 'auto',
      dataMinWidth = '';

      imgAlt = data.title,
      flipImageSrcSet = '';

    var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
      boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
      boostPFSThemeConfig.custom.active_image_swap == true;

    for (var i = 0; i < rangeWidths.length; i++) {
      dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
      dataWidths += rangeWidths[i];

      if (activeSwapImage) {
        flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
      }

      if (i < rangeWidths.length - 1) {
        dataSrcSet += ', ';
        dataWidths += ', ';

        if (activeSwapImage) {
          flipImageSrcSet += ', ';
        }
      }
    }
    // reverse loop
    
    

    if (images.length > 0) {
      aspectRatio = images[0]['width'] / images[0]['height'];
      paddingTop = 1 / aspectRatio * 100;
    }
    //console.log('feat:'+ Utils.getFeaturedImage(images));
    featuredImage = Utils.getFeaturedImage(images);

    var imgHTML = '';
        imgHTML = '<img class="boost-pfs-filter-product-item-main-image js-generated" loading="lazy"' +
                  'srcset="' + dataSrcSet + '" ' +  
                  'data-src="'+ Utils.getFeaturedImage(images)+'"' +
                  'sizes="' + boostPFSFilterConfig.general.boostPFSSizes + '" ' +  
                  'src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="' +  
                  'alt="' + imgAlt + '" ';
        imgHTML += '/>';
    html += '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link" ';
    html += 'style="padding-top:' + paddingTop + '%;">';
    html += imgHTML;
    html += '</a>';

    return html;
  }

  function buildVendor(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
      boostPFSThemeConfig.custom.show_vendor == true) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildPrice(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_price') &&
      boostPFSThemeConfig.custom.show_price) {
      html = '<p class="boost-pfs-filter-product-item-price">';
      if (onSale) {

        html += '<span class="boost-pfs-filter-product-item-sale-price">' + Utils.formatMoney(data.price_min) + '</span>';
        html += '<s>' + Utils.formatMoney(data.compare_at_price_min) + '</s> ';
      } else {
        if (priceVaries) {
          html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label_basic.from) + ' ' + '</span>';
        }
        html += '<span class="boost-pfs-filter-product-item-regular-price">' + Utils.formatMoney(data.price_min) + '</span>';
      }
      html += '</p>';
    }
    return html;
  }

  function buildLabels(data) {
    // Build Sold out label
    var soldOutLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_enable') &&
      boostPFSThemeConfig.custom.sold_out_enable && soldOut) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
    }
    // Build Sale label
    var saleLabel = '';
    var salePercent = '';
    if (boostPFSThemeConfig.custom.sale_label_enable && onSale && !soldOut) {
      if (boostPFSThemeConfig.custom.sale_label_display == 'sale_percent'){
        salePercent = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_max);
      }
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{%}}/g, salePercent + '%');
    }
    // Build Labels
    return soldOutLabel + saleLabel;
  }

  // BUILD LABEL PRODUCT WITH TAGS
  function buildTagLabels(data, showall) {
    if (boostPFSThemeConfig.custom.tag_label_enable) {
      if (showall) {
        var tagLabel = '';
        if (data.tags) {
          for (var i = 0; i < data.tags.length; i++) {
            var tag = data.tags[i];
            if (tag.indexOf("pfs:label") !== -1) {
              var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
              tagLabel += preTagLabel;
            }
          }
        }
      } else {
        var tagLabel = '';
        if (data.tags) {
          for (var i = data.tags.length - 1; i >= 0; i--) {
            tag = data.tags[i];
            if (tag.indexOf("pfs:label") !== -1) {
              var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
              tagLabel += preTagLabel;
              break;
            }
          }
        }
      }
      return tagLabel;
    } else {
      return "";
    }
  }
  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  // Build Color Swatches
  function buildProductOptionSwatches(data) {
    //console.log('buildProductOptionSwatches');
    //console.log(data); 
    
    var swatchesProductOptionHtml = '';
    if (boostPFSThemeConfig.custom.swatch_enable) {
      var swatchApplyFor = ['color', 'img', 'pro_img', 'text'];
      for(var i = 0; i < swatchApplyFor.length; i++){
        var optionNames = boostPFSThemeConfig.custom["swatch_by_" + swatchApplyFor[i] + "_apply"].split(',').filter(onlyUnique);
        var swatchShape = boostPFSThemeConfig.custom["swatch_by_" + swatchApplyFor[i] + "_shape"];
        var swatchType = swatchApplyFor[i];
        
        

        for(var j=0; j < optionNames.length; j++){
          var optionName = optionNames[j].trim();
          var filterSwatchTitle = optionName,
          swatchArr = [],
          countSwatch = 0,
          swatchValues = [],
          swatchLimit = 20;
      

          var dataImgSize = '360',
            bgSize = '40x',
            rangeWidths = boostPFSRangeWidths,
            dataImgSrc = '',
            swatchName = '#ffffff',
            bgImageSrc = '',
            viewMoreLabel = 'More ' + filterSwatchTitle;

          if (typeof data.options_with_values != 'undefined' && data.options_with_values.length > 0) {
            swatchArr = data.options_with_values.filter(function(option) {
              return option.name == optionName;
            });
            if (swatchArr.length > 0) {
              countSwatch = swatchArr[0].values.length;

              if (swatchLimit > countSwatch) {
                swatchLimit = countSwatch;
              }
              swatchValues = swatchArr[0].values;

              var colorMappingVal = '';
            $.each(data.metafields, function(index,metafieldsObjectColor){
                var key = metafieldsObjectColor.key;
                if (key == 'color_mapping') {
                    colorMappingVal = metafieldsObjectColor.value.toLowerCase();
                }
            });

              swatchesProductOptionHtml += '<ul data-mapping="'+colorMappingVal+'" class="boost-pfs-filter-item-swatch boost-pfs-filter-item-swatch-option' + optionName + ' boost-pfs-filter-item-swatch-shape-' + swatchShape + ' boost-pfs-filter-item-swatch-type-' + swatchType + '">';

              for (var sIndex = 0; sIndex < swatchLimit; sIndex++) {
                swatchName = swatchValues[sIndex].title;
                swatchVariant = data['variants'][sIndex];
                sImageIndex = swatchValues[sIndex].image || '';
                if (sImageIndex != '') {
                    //dataImgSrc = Utils.optimizeImage(data.images[sImageIndex], dataImgSize + 'x') + ' ' + dataImgSize + 'w';
                    dataImgSrc = '';
                    for (var i = 0; i < rangeWidths.length; i++) {

                        dataImgSrc += Utils.optimizeImage(data.images[sImageIndex], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
                        if (i < rangeWidths.length - 1) {
                            dataImgSrc += ', ';
                        }
                    }       
                }
                if (swatchType) {
                  switch (swatchType) {
                    case 'img':
                      bgImageSrc = boostPFSAppConfig.general.file_url.replace(/\?/,  Utils.slugify(swatchName) + '_40x.jpg?v=');
                      break;
                    case 'pro_img':
                      bgImageSrc = Utils.getFeaturedImage(data.images_info, bgSize);
                      if (sImageIndex != '') {
                        bgImageSrc = Utils.optimizeImage(data.images[sImageIndex], bgSize);
                      }
                      break;
                    default:
                      bgImageSrc = boostPFSAppConfig.general.file_url.replace(/\?/,  Utils.slugify(swatchName) + '_40x.jpg?v=');
                  }
                }
                //console.log('swat:'+data.images[sImageIndex]);
                //console.log('feat:'+featuredImage.replace('_large.', '.'));

                var featImg = featuredImage.replace('_large.', '.');
                // auto add selected class to first swatch
                if (featImg == data.images[sImageIndex]) {
                  selectedClass = 'selected'; 
                } else {
                  selectedClass = ''; 
                }
               

                // check if there is any available variant related to thic color 
                // if yes set swatchAvailable to true
                var swatchAvailable = false;
                var selectedEyeSize = 0;
                colFilterQuery = getQueryParams(document.location.search);
                if (colFilterQuery.sizes != undefined) {
                  var PC02BSizeValue = colFilterQuery.sizes.split(' [')[0].replace('Sizes_', '');
                  //console.log('PC02BSizeValue:'+PC02BSizeValue);
                  $.each(data.tags, function(key, tagSize) {
                    if (tagSize.indexOf('PC02B:'+PC02BSizeValue) > -1) {
                      //console.log('tttt:'+tagSize);
                      selectedEyeSize = parseInt(tagSize.replace('PC02B:','').match(/\d+/)[0]);
                      return false;
                    }  

                  });    
                }  
                // set active color array
                var colorArr = [];
                $.each(data.variants, function(index,variantEntry){
                  if (variantEntry.option_size != undefined) {
                      var optionSizeNum = parseInt(variantEntry.option_size.match(/\d+/)[0]);
                      hasSize = true;
                      if (selectedEyeSize == optionSizeNum) {
                        colorArr.push(variantEntry.option_color);
                      }
                    }
                });      
                $.each(data.variants, function(index,variantEntry){
                  
                  if (variantEntry.available == true) {
                    var varColor  = variantEntry.option_color;
                    if (varColor == swatchName) { 
                      swatchAvailable = true;
                      swatchVariant = variantEntry;
                      
                      if (colorArr.length > 0) {
                        
                        var activeColor = $.inArray(varColor, colorArr);
                        //console.log('varColor:'+varColor);
                        //console.log(activeColor);
                        if (activeColor == -1) {
                          swatchAvailable = false;  
                        }


                      } 
                      
                      
                      return false;
                    }

                  }
                });

          var availClass = '';
          if (swatchAvailable) {
          
          }  else {
            availClass = 'unavailable';
          }
                  swatchesProductOptionHtml += '<li class="'+availClass+'">';
                    if(swatchType == 'text'){
                      swatchesProductOptionHtml += '<a title="' + swatchName + '" href="' + Utils.buildProductItemUrl(data) + '?variant=' + swatchVariant.id + '">' + swatchName + '</a>';
                    } else {
                      if(boostPFSThemeConfig.custom.show_swatch_tooltip){
                        swatchesProductOptionHtml += '<div class="boost-pfs-product-item-tooltip">' + swatchName + '</div>';
                      }
                      swatchesProductOptionHtml += '<span class="'+selectedClass+'" tabindex="0" data-handle="'+Utils.slugify(swatchName)+'"  aria-label="' + swatchName + '" ' +
                          'style="background-color: ' + swatchName + '; ';
                      if (bgImageSrc != '') {
                          swatchesProductOptionHtml += 'background-image: url(' + bgImageSrc + ');" ';
                      } else {
                          swatchesProductOptionHtml += '" ';
                      }
                      if (dataImgSrc != '') {
                          swatchesProductOptionHtml += 'data-img="' + dataImgSrc + '" ';
                      }
                      swatchesProductOptionHtml += 'aria-label="'+swatchName+'" role="button"' ;
                      swatchesProductOptionHtml += 'data-href="' + Utils.buildProductItemUrl(data) + '?variant=' + swatchVariant.id + '" ';

                      swatchesProductOptionHtml += '></span>';
                    }
                  swatchesProductOptionHtml += '</li>';
              }
            

              if (countSwatch > swatchLimit) {
                swatchesProductOptionHtml += '<li class="boost-pfs-filter-item-swatch-more">';
                swatchesProductOptionHtml += '<a href="{{itemUrl}}" title="' + viewMoreLabel + '">+' + (countSwatch - swatchLimit) + '</a>';
                swatchesProductOptionHtml += '</li>';
              }

              swatchesProductOptionHtml += '</ul>';
            }
            
          

          } // end swatch not undefined
        }
        
      }
    }
    return swatchesProductOptionHtml;
  }

  // Build Color Swatches
  function eventColorSwatches(event) {
    jQ('.boost-pfs-filter-item-swatch li span').each(function() {
      var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
      if (event == 'hover') {
        jQ(this).hover(function() {
          var newImage = jQ(this).data('img');
          img.attr('srcset', newImage);
        });
      }
      if (event == 'click') {
        jQ(this).click(function() {
          var newImage = jQ(this).data('img');
          img.attr('srcset', newImage);
        });
      }
      jQ(this).focus(function() {
        if (jQ('body').hasClass('boost-pfs-ada')) {
          var newImage = jQ(this).data('img');
          img.attr('srcset', newImage);
        }
      });
    });
  }

  function buildReview(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
      boostPFSThemeConfig.custom.show_product_review == true) {
      var yotpoAverage = 0;
      var yotpoTotal = 0;
      
      $.each(data.metafields, function(index,metafieldsObject){
        var namespace = metafieldsObject.namespace;
        var key = metafieldsObject.key;
          if (namespace == 'yotpo' && key == 'richsnippetshtml') {
            var htmlString = metafieldsObject.value;

            // Regex to extract votes and average
            var votesMatch = htmlString.match(/itemprop="votes" content:"([\d.]+)"/);
            var averageMatch = htmlString.match(/itemprop="average" content:"([\d.]+)"/);

            if (votesMatch && averageMatch) {
              var votes = votesMatch[1];
              var average = Math.round(averageMatch[1]);
              //console.log("Votes:", votes); 
              //console.log("Average:", Math.round(average)); 
              html = '<div class="bottomLine custom yotpoTotal" data-rating="'+average+'"><span class="yotpo-stars"><span class="rating-star"></span><span class="rating-star"></span><span class="rating-star"></span><span class="rating-star"></span><span class="rating-star"></span><span class="sr-only">'+average+' star rating</span></span><span class="text-m">'+votes+' Reviews</span></div>'
            }
          }
      });
    }
    return html;
  }

  function buildActiveSwapClass(data) {
    if (!Utils.isMobile() && images.length > 1 &&
      boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
      boostPFSThemeConfig.custom.active_image_swap == true) {
      return 'has-bc-swap-image';
    }
    return '';
  }



  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    if (boostPFSThemeConfig.custom.show_sort_by && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || '';
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          activeClass = '';
          if (paramSort == k) {
            activeClass = 'boost-pfs-filter-sort-item-active';
          }
          sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function() {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
    }

    var labelSort = '';
    var paramSort = Globals.queryParams.sort || '';
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting_heading;
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  }

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function() {
    var _this = this;
    jQ('.boost-pfs-filter-filter-dropdown a').click(function(e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).data('sort'));
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });

    jQ(".boost-pfs-filter-custom-sorting > button").click(function() {
      jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
    });

    jQ(Selector.filterTreeMobileButton).click(function() {
      jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
    });

    jQ(document).on('click', function (e) {
      if (jQ(e.target).parents('.boost-pfs-filter-top-sorting').find(".boost-pfs-filter-filter-dropdown").length === 0) {
        jQ('.boost-pfs-filter-filter-dropdown').hide().parent().removeClass('boost-pfs-filter-sort-active');
      }
    });
  };
  // For Toolbar - Build Display type
  ProductDisplayType.prototype.compileTemplate = function() {
    
    var itemHtml = '<span>' + boostPFSThemeConfig.label.toolbar_viewas + '</span>';
    if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
      if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
          itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
          itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
          itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>';
          itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
          itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
          itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
      } else {
          itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
          itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
      }
    } else {
      if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
      } else {
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
      }
    }

    itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

    return itemHtml;
  };

  var originalRenderProductDisplayType = ProductDisplayType.prototype.render;
  ProductDisplayType.prototype.render = function() {
    // Call the original function in our app lib.
    // We don't have to copy a very big function out here to modify.
    // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
    originalRenderProductDisplayType.call(this);

    // Do your custom code after the original function has run
    // Active current display type
    if (this.$element.length) {
      this.$element.find(this.selector.productDisplayTypeList).removeClass('active');
      this.$element.find(this.selector.productDisplayTypeGrid).removeClass('active');
      if (Globals.queryParams.display == 'list') {
        this.$element.find(this.selector.productDisplayTypeList).addClass('active');
      } else if (Globals.queryParams.display == 'grid') {
        if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
          var curentGridColumn = boostPFSThemeConfig.custom.products_per_row;
          this.$element.find(this.selector.productDisplayTypeGrid).each(function(){
          var $parent = jQ(this).parent();
          var $cssNames = jQ('.boost-pfs-filter-top-display-type').attr('class').split(' ');
          var $activeClass = $cssNames[$cssNames.length - 1];
          var indexCurrentColumn = $activeClass.split('-')[$activeClass.split('-').length - 1];
          
          if($parent.hasClass('boost-pfs-filter-view-as-click') && jQ(this).data('view') == $activeClass){
              jQ(this).addClass('active');

              // jQ('.boost-pfs-filter-product-item').removeClass(function(index, css) {
              // return (css.match (/(^|\s)boost-pfs-filter-grid-width-\S+/g) || []).join(' ');
              // }).addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);

              var arrClss = jQ('.boost-pfs-filter-product-item').attr('class').split(' ');
              var gridIndex = arrClss.findIndex((ele) => ele.match (/(^|\s)boost-pfs-filter-grid-width-\S+/g));
              jQ('.boost-pfs-filter-product-item').removeClass(arrClss[gridIndex]);
              jQ('.boost-pfs-filter-product-item').addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);

              // jQ('.boost-pfs-filter-product-item').className = jQ('.boost-pfs-filter-product-item').className.replace(/(^|\s)boost-pfs-filter-grid-width-\S+/g , '');
              // jQ('.boost-pfs-filter-product-item').addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);

          } else if(!$parent.hasClass('boost-pfs-filter-view-as-click') && jQ(this).data('view').split('-')[1] == curentGridColumn) {    
              jQ(this).addClass('active');
          }
        });

        } else {
          this.$element.find(this.selector.productDisplayTypeGrid).addClass('active');
        }
      }
    }
  };

  // Build Show Limit
  ProductLimit.prototype.compileTemplate = function() {
    var html = '';
    if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {

      var numberList = Settings.getSettingValue('general.showLimitList');
      if (numberList != '') {
        // Build content
        var showLimitItemsHtml = '';
        var arr = numberList.split(',');
        for (var k in sortingArr) {
          showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
        }
        html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      }
    }
    return html;
  };
  // Build Breadcrumb
  Breadcrumb.prototype.compileTemplate = function(colData) {
    if (!colData) colData = this.collectionData;
    var breadcrumbItemsHtml = '';
    if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
      if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
        var colInfo = colData.collection;
        if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
          breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
        } else {
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
        }
      } else {
        breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
      }
    }
    return breadcrumbItemsHtml
  };

  /************************** END BUILD TOOLBAR **************************/

  // Add additional feature for product list, used commonly in customizing product list
  /*
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;

    if (typeof Yotpo !== "undefined") { 
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
    } 

    // Intergrate Review Shopify
    if (window.SPR &&
      typeof window.SPR.initDomEls == 'function' &&
      typeof window.SPR.loadBadges == 'function' &&
      boostPFSThemeConfig.custom.show_product_review) {
      window.SPR.initDomEls();
      window.SPR.loadBadges();
    }
  };
  */

  // Build additional elements
  Filter.prototype.afterRender = function(data) {
    if (!data) data = this.data;


    var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
    if (data.total_product == 1) {
      totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>';
    }
    if (data.total_product == 0) {
      jQ(".boost-pfs-filter-default-toolbar-inner").addClass('boost-pfs-filter-toolbar-product-0');
    }
    jQ('.boost-pfs-filter-total-product').html(totalProduct);

    jQ('body').find('.boost-pfs-filter-skeleton-button').remove();

    // Prevent double tap on iOS
    var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isiOS) {
      Utils.isMobile() && jQ(".boost-pfs-filter-product-item").find("a").on("touchstart", function() {
        isScrolling = !1
      }).on("touchmove", function() {
        isScrolling = !0
      }).on("touchend", function() {
        isScrolling || (window.location = jQ(this).attr("href"))
      });
    }

    // Build Image Swap. Put this function here to impprove the pagespeed.
    swapImage(data);
        var gridV2 = false;
        if ($('body').hasClass('gridV2')) {
          gridV2 = true;
        } 
        //console.log('gridV2 aaa', gridV2); 
        if (gridV2 == true) {
          $('.boost-pfs-filter-product-item .ls-image-box[data-handle]').each(function() {
            if ($(this).find('img').length == 0) {
              var handle = $(this).attr('data-handle');
              var $this = $(this);
              $this.html('');
                $.get('/products/'+handle+'?view=ls', function(data) {
                  $this.html(data);
                  $('.productGrid .customCard .card__information').matchHeight();
                });
            }  
          });
        }


    // Build Equal Height
    if (Globals.queryParams.display !== 'list') {
      equalHeight(data);
    };

    jQ(window).resize(function() {
      if (Globals.queryParams.display !== 'list') {
        equalHeight(data);
      }
    });

    // Build Event Color Swatch
    if (boostPFSThemeConfig.custom.swatch_change_img != 'none') {
      eventColorSwatches(boostPFSThemeConfig.custom.swatch_change_img);
    }

    if (typeof boostRemoveImageLoadingAnimation == 'function') {
      boostRemoveImageLoadingAnimation(jQ(Selector.products).find('[data-boost-image-loading-animation]'));
    }

      // Filter Sticky 
      if (boostPFSThemeConfig.custom.hasOwnProperty('enable_filter_sticky_d') && boostPFSThemeConfig.custom.enable_filter_sticky_d && !Utils.isMobile()) {
          if(jQ('.boost-pfs-filter-left-col-inner').length > 0){
            var stickyElemet = '.boost-pfs-filter-left-col-inner';
            var stickyElementParent = '.boost-pfs-filter-left-col';
            var startElement = '.boost-pfs-filter-products';
            jQ(stickyElemet).stickTo(startElement,stickyElementParent);
          }
      }
      

    // Init Sticky Mobile */
    stickyFilterMobile();
    document.addEventListener('scroll', function() {
      stickyFilterMobile();
    });

    // Init Sticky Horizontal
    stickyFilterHorizontal();
    document.addEventListener('scroll', function() {
      stickyFilterHorizontal();
    });

    // Layout Fullwidth Page
    if (boostPFSThemeConfig.custom.hasOwnProperty('layout_type') && boostPFSThemeConfig.custom.layout_type == 'fullwidth' && !Utils.isMobile()) {
      jQ('body').addClass('boost-pfs-filter-fullwidth-page');
    }

    // set query params
    var renderTimer;
    colFilterQuery = getQueryParams(document.location.search);
    //console.log(data);

    // trigger click to set  color attribute
    //$('.productGrid .boost-pfs-filter-product-item .boost-pfs-filter-item-swatch li span.selected').trigger('click');


        
      // set item url parameter
      var globalAddedUrlArr = [];
      var globalAddedUrl = '';

      //console.log('colFilterQuery');
      //console.log(colFilterQuery);

      // // push eye sizes
      if (colFilterQuery.eye_size != undefined) {
          globalAddedUrlArr.push('eye_size='+slugify(colFilterQuery.eye_size.toLowerCase().split(',').pop().replace('eye size_', '').replace(/[^A-Z0-9]+/ig, "-")));
      }
      // // push width
      if (colFilterQuery.width != undefined) {
          globalAddedUrlArr.push('width='+slugify(colFilterQuery.width.toLowerCase().split(',').pop().replace('width_', '').replace(/[^A-Z0-9]+/ig, "-")));
      }

      $.each(globalAddedUrlArr, function(index, urlItem) {
          if (index == 0) {
              globalAddedUrl = '?' + urlItem;
          } else {
              globalAddedUrl += '&' + urlItem
          }
      });
      if (theme.custom.collectionTitle != undefined) {
        globalAddedUrl += '?atcsource=cp'
      }
      // console.log('globalAddedUrl');
      // console.log(globalAddedUrl);
      

      // auto add url param and auto click swatch
      clearTimeout(renderTimer);
      renderTimer = setTimeout(function() {
        //console.log('render:'+$('.boost-pfs-filter-products .product-card').length);
        // check for size filter and add url mapping for pc02b
        if (colFilterQuery.sizes != undefined) {
          var filterSizesMapArr = boostPFSThemeConfig.custom.filterSizesMap.split(', ');
          $.each(filterSizesMapArr, function( key, value ) {
              if (value.indexOf(colFilterQuery.sizes) > -1) {
                  sizeHandle = '-'+value.split(': ')[1];
              }
          });
          var selectedSize = $('#boost-pfs-filter-tree-pf-t-sizes .selected .boost-pfs-filter-option-value').text();
          $('.boost-pfs-filter-product-bottom .sizeLabel').text(selectedSize.split(' [')[0]);
        } else {
          sizeHandle = '';
        }

        $('.boost-pfs-filter-products .product-card').each(function() {
          //console.log('each')
            var pThis = $(this);
            var overlayLink = $(this).find('.overlayLink');
            var originalHref = overlayLink.attr('data-href').replace(sizeHandle,'');
            var pc2obFlag = $(this).closest('.customCard').attr('data-pc02b-flag');
    
            var swatchElem = $(this).find('.boost-pfs-filter-item-swatch');

            var sizeHandleEntry = sizeHandle;
            if (pc2obFlag == 'true') {
              sizeHandleEntry = '';
            }  

            var pc02bTag = pThis.closest('.customCard').attr('data-pc02b-tag');
            if (pc02bTag == '' || pc02bTag == 'undefined') {
              //sizeHandle = ''; 
              //overlayLink.attr('href', originalHref+cardAddedURL); 
              overlayLink.attr('href', originalHref); 
            } else {
              //overlayLink.attr('href', originalHref+sizeHandleEntry+cardAddedURL); 
              overlayLink.attr('href', originalHref+sizeHandleEntry); 
            }

            //console.log('overlay url');
            //console.log(originalHref+sizeHandle+globalAddedUrl)
            //console.log('colFilterQuery', colFilterQuery.color);

            
            // auto select swatch based on color param
            if (colFilterQuery.color != undefined) {
                var colorParam = colFilterQuery.color.toLowerCase().split(',').pop().replace('color_', '').replace('colors_', '').replace(/[^A-Z0-9]+/ig, "-");
                
                
                
                
                // auto click color swatch
                swatchElem.find('span[data-handle*="' + colorParam + '"]').first().trigger('click');
                var matchedColorCount = swatchElem.find('span[data-handle*="' + colorParam + '"]').length;
                //console.log('sss:'+swatchElem.find('span[data-handle*=' + colorParam + ']').attr('data-handle'));
                //console.log('colorParam', overlayLink.attr('aria-label'), colorParam, matchedColorCount);

                
                // if no item is clicked check mapping values
                var colorMap = swatchElem.attr('data-mapping');
                if (colorMap != '' && matchedColorCount == 0) {
                    var mappingArr = colorMap.split(', ');
                    $.each(mappingArr, function(index, mapItem) {
                        var mapKey = mapItem.split(': ')[0];
                            mapKey = slugify(mapKey);
                        var mapVal = mapItem.split(': ')[1];
                        //console.log('mapKey:'+mapKey, mapVal, overlayLink.attr('aria-label'));
                        if (colorParam == mapVal) {
                          //console.log('mapKey:'+mapKey, mapVal, overlayLink.attr('aria-label'));
                          swatchElem.find('span[data-handle*="' + mapKey + '"]').first().trigger('click');
                        }
                    });
                }
            } else {
              if (pThis.hasClass('clicked') == false) {
                if (swatchElem.find('.selected').length == 0) {
                  //swatchElem.find('li span').first().trigger('click');
                } else {
                  //swatchElem.find('.selected').trigger('click');
                  //swatchElem.find('li span').first().trigger('click');
                }
                //$('.productGrid .boost-pfs-filter-product-item .boost-pfs-filter-item-swatch li span.selected').trigger('click');
              } 
            }
            //console.log('clicked:'+pThis.hasClass('clicked'))
            //swatchElem.find('.selected').trigger('click');
        });
      }, 300);
      
    gridMarketing();

    $('.tipTrigger').remove();
    $('.boost-pfs-filter-qtip-content').each(function() {
      var tipID = $.trim($(this).text());
      var tipTrigger = '<a href="'+tipID+'" class="tipTrigger ajax-pop"><span>?</span></a>';
      $(this).closest('.boost-pfs-filter-option-title').find('.boost-pfs-filter-option-title-heading').after(tipTrigger); 
    });
    // $('.tipTrigger').magnificPopup({
    //     type:'inline',
    //     midClick: true 
    // });
    /*
    var collectionName = $('.collectionBox').attr('data-name');
    $('.boost-pfs-filter-option-item').not('.selected').each(function() {
      var filterTxt = $(this).find('.boost-pfs-filter-option-value').text();
      var fThis = $(this);
      if (filterTxt == collectionName) {
        //alert(filterTxt);
        setTimeout(function() {
          fThis.trigger('click');
        }, 300);
      }
    });
    */


    $('body').addClass('pfs-rendered');
    setTimeout(function() {
      $('body').removeClass('pfs-rendering');
      checkHTOItem();
      
    }, 100);
    setTimeout(function() {
      var filterQuery = getQueryParams(document.location.search);
      var filterSizes = {
          'Kids X-Small [Ages 5-7]': '48',
          'Kids Small [Ages 6-9]': '49, 51',
          'Kids Medium [Ages 9-14]': '52, 53, 57',
          'Kids Large [Ages 12-17]': '52, 55', 
          'Kids X-Large [Ages 14-18]': '57, 58, 60',
          'Adult Narrow': '49, 51, 52, 53, 55',
          'Adult Average': '53, 55', 
          'Adult Wide': '53, 55'
      }
      // adjust eye size based on array
      if (filterQuery.sizes) {
        var selectedSize = filterQuery.sizes.split('Sizes_')[1];
        $.map(filterSizes, function(val, key) {
          //console.log("Value is :" + val);
          //console.log("key: " + key);
          if (selectedSize == key) {
            var eyeSizeArr = val.split(', ');
            if ($('#boost-pfs-filter-tree-pf-t-eye-size').length > 0) {
              $('#boost-pfs-filter-tree-pf-t-eye-size .boost-pfs-filter-option-value').each(function() {
                var filterVal = $(this).text();
                if ($.inArray(filterVal, eyeSizeArr) == -1) {
                  
                  if ($(this).closest('li').hasClass('selected')) {
                    $(this).closest('li').trigger('click')
                  }
                  $(this).closest('li').hide();
                }          
              });
            }
          }
        });
      }
     }, 300); 






    setTimeout(function() {
      var scrollPos = 0;
      if (pageLoad == false) {
        scrollPos = 0;

        // if ($('.boost-pfs-filter-refine-by-wrapper .boost-pfs-filter-refine-by-items').length > 0) {
        //   scrollPos = $('.boost-pfs-container-default-box').offset().top - $('#shopify-section-header').height();
        // }
        // var colFilterQuery = getQueryParams(document.location.search);
        // var filterSort = colFilterQuery.sort;
        // if (filterSort != undefined) {
        //   scrollPos = $('.boost-pfs-container-default-box').offset().top - $('#shopify-section-header').height();
        // }
      

        pageLoad = true;
        $('html, body').animate({
            scrollTop: scrollPos
        }, 0);
      } else {
        //scrollPos = $('.boost-pfs-container-default-box').offset().top - $('#shopify-section-header').height();

      }

      


    }, 100);


    //console.log('after render');


    // after render 
  };

  // Filter Sticky
  jQ.fn.stickTo = function(startElement, stickyElementParent) {
    /* constants */    
    var showingHeader = false;
    var headerHeight = 0; /* change the header height here */
    var headerSelector = '';  
    var $window = jQ(window);  
    var $startElement = jQ(startElement);               
    var _this = this;          

    /* variables */
    var lastScrollTop = window.pageYOffset || document.body.scrollTop;  

    /* sticky method */
    var setPosition = function() {
      /* declarations */
      var width = jQ(stickyElementParent).outerWidth();
      var $windowHeight = $window.height();
      var $contentHeight = $startElement.outerHeight(true);     
      var $contentTop = $startElement.offset().top;      

      var sidebarHeight = _this.outerHeight();
      var sidebarTop = _this.offset().top;
      var sidebarBottom = sidebarTop + sidebarHeight;

      var scrollTop = window.pageYOffset || document.body.scrollTop;                        
      var scrollBottom = scrollTop + $windowHeight;  
      var isScrollingDown = (scrollTop > lastScrollTop);

      var endPos = $contentTop + $contentHeight;
      
      /* Match Header Height Sticky */
      if(jQ('.site-header-wrapper .action-area').length > 0){
      /* For the Boundless theme */
          headerSelector = '.site-header-wrapper .action-area';
        } else if (jQ('.site-header .nav-bar').length > 0) {
      /* For the Venture theme */
          headerSelector = '.site-header .nav-bar';
      } else if (jQ('.site-header--fixed').length > 0) {
        headerSelector = '.site-header--fixed';
      } else if (jQ('.header-wrapper--fixed').length > 0) {
        headerSelector = '.header-wrapper--fixed';
      }

      if(headerSelector != ''){
      headerHeight = jQ(headerSelector).outerHeight();
      }

      document.addEventListener('scroll', function() {
        showingHeader = false;
        /* For the Boundless, Venture theme */
        if(jQ('.js-sticky-action-bar').length > 0 || jQ('.site-header .sticky--open').length > 0 || jQ('.site-header--fixed' || jQ('.header-wrapper--fixed'))){
            showingHeader = true;
        }
      });
      /* End Match Header Height Sticky */

      if (sidebarHeight > $contentHeight) {
        _this.removeClass('boost-pfs-filter-stick');
        jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');           
        _this.css({
        position: 'initial'
        });
        return;
      }

      if (scrollTop <= $contentTop) { /* Initial Position */
        _this.removeClass('boost-pfs-filter-stick');
        jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');          
        _this.css({
          position: 'initial',
          width: '100%'
        });
        return;
      }      

      if ((scrollBottom >= endPos)) { /* End Position  */          
        var absolutePos = endPos - sidebarHeight - $contentTop;
        if (absolutePos > 0) {
          _this.removeClass('boost-pfs-filter-stick');
          jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');            
          _this.css({
            position: 'absolute',
            top: absolutePos,
            bottom: 'unset',
            width: width
          });
        } 
        return;
      }
      /* when scrolling down */  
      if (isScrollingDown) {          
        if (scrollBottom < sidebarBottom) { /* Until reach the sidebar bottom  */
          if (_this.css('position') !== 'relative') {
            _this.removeClass('boost-pfs-filter-stick');
            jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');          
            _this.css({
              position: 'relative',
              top: sidebarTop - $contentTop,
              bottom: 'unset',
              width: '100%'
            });          
          }
        } else if (scrollBottom >= sidebarBottom && scrollTop > $contentTop) { /* Sticky sidebar */                
          _this.addClass('boost-pfs-filter-stick');
          jQ('body').addClass('boost-pfs-filter-stick-vertical-body');                        

          _this.css({
            position: 'fixed',
            top: showingHeader ? (headerHeight + 'px') : '20px',
            bottom: $windowHeight > (sidebarHeight + headerHeight) ? 'unset' : 0,
            width: width,
            left: 'auto'
          });
        }
      } else { /* when scrolling up */     
        if ((scrollTop - headerHeight) > sidebarTop) {  /* Until reach the sidebar top  */   
          if (_this.css('position') !== 'relative') {
            _this.removeClass('boost-pfs-filter-stick');
            jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');           
            _this.css({
              position: 'relative',
              top: sidebarTop - $contentTop,
              bottom: 'unset',
              width: '100%'
            });          
          }
        } else if (scrollTop <= (endPos - sidebarHeight)) { /* Sticky sidebar */
          _this.addClass('boost-pfs-filter-stick');
          jQ('body').addClass('boost-pfs-filter-stick-vertical-body');                        

          _this.css({
            position: 'fixed',
            top:  showingHeader ? (headerHeight + 'px') : '20px',
            bottom: 'unset',
            width: width,
            left: 'auto'
          });
        }
      }
      /* End when scrolling down */ 
      /* save last scroll position */
      lastScrollTop = window.pageYOffset || document.body.scrollTop;
    };

    /* on window resize */
    jQ(window).resize(function() {        
      setPosition();
    });

    /* on scroll */
    document.addEventListener('scroll', function() {
      setPosition();
    });
    setPosition();
    
    jQ(document).on('click', '.boost-pfs-filter-button.boost-pfs-filter-option-title-heading', function() {
        setTimeout(setPosition, 400);
    });
  };
  /* End filter sticky */
  function removeClassByPrefix(node, prefix) {
    var regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
    node.className = node.className.replace(regx, '');
    return node;
  }

  var original_onClickEventProductDisplayType = ProductDisplayType.prototype._onClickEvent;
  ProductDisplayType.prototype._onClickEvent = function(event) {
    // Call the original function in our app lib.
    // We don't have to copy a very big function out here to modify.
    // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
    original_onClickEventProductDisplayType.call(this, event);

    // Do your custom code after the original function has run
    /*  View As Type 2/3/4/5/6 */
    
    if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
        jQ('.boost-pfs-filter-top-display-type').addClass('boost-pfs-filter-view-as-click');
        var currentClass = jQ(event.target).data('view');
        jQ('.boost-pfs-filter-top-display-type')[0].className = jQ('.boost-pfs-filter-top-display-type')[0].className.replace(/(^|\s)grid-\S+/g , '');
        jQ('.boost-pfs-filter-top-display-type').addClass(currentClass);
    }
  }

  ProductListPlaceholder.prototype.render = function() {
    // Set limit number for product skeleton
    var placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow;
    // Build placeholder items
    var placeholderItem = this.compileTemplate();
    this.$element = [];
    for (var i = 0; i < placeholderLimit; i++) {
      this.$element.push(jQ(placeholderItem));
    }
    // Show placeholder before send filter request OR hide it after get filter data
    if (!this.isFetchedProductData) {
      this.setShow();
    } else {
      this.setHide();
    }
    $('body').addClass('pfs-rendering');
  }

  ProductListPlaceholder.prototype.compileTemplateExtra = function() {
    var display = Globals.queryParams.display
    switch (display) {
      case 'list':
        //Todo: Build placeholder for List mode
        var template = boostPFSTemplate.productListPlaceholderHtml;
        var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio);
        var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4; // It mean w1:h1.4
        /**
         * Set product class for product skeleton (to set column, style, etc.)
         * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
         */
        break;
    }
    return template
      .replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
      .replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
      .replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
      .replace(/{{paddingTop}}/g, imgRatio * 100)
  }

  /* Prevent conflict with theme vendor js */
  Array.prototype.insert = function(a, b) {}

  /* Math qual Height */
  function equalHeight(data) {
    var equal_i = -1;
    var equal_els = [];
    var equal_element = null;

    // Equal Height Title
    jQ('.boost-pfs-filter-product-item').each(function(i, element) {

      var offsetTop = jQ(element).offset().top;
      if (!equal_element || equal_element.offset().top !== offsetTop) {
        equal_element = jQ(element);
        equal_i++;
      }

      if (!equal_els[equal_i]) {
        equal_els[equal_i] = [];
      }
      equal_els[equal_i].push(element);
    });

    for (var i = 0; i < equal_els.length; i++) {
      var max = 0;
      var maxRatio = 0;
      var iLength = equal_els[i].length;

      for (var j = 0; j < equal_els[i].length; j++) {
        var item = equal_els[i][j];
        var height = jQ(item).find('.boost-pfs-filter-product-bottom-inner').height();
        max = Math.max(max, height);

      }

      jQ(equal_els[i]).find('.boost-pfs-filter-product-bottom-inner').css({ 'min-height': max });

    }

    var aspect_ratio = boostPFSFilterConfig.general.aspect_ratio;

    if (aspect_ratio != 'false') {
      var cropImagePosition = boostPFSFilterConfig.general.cropImagePossitionEqualHeight;

      var widthImage = jQ('.boost-pfs-filter-product-item').width();
      var indexData = 0;

      // For Ratio
      if (aspect_ratio != 'false' && aspect_ratio != 'auto') {
        var heightImage = 0;
        var widthImage = jQ('.boost-pfs-filter-product-item').width();
        if (aspect_ratio != 'false' && aspect_ratio != 'auto' && aspect_ratio != 'other') {
          var ratioWidthHeight = boostPFSThemeConfig.custom.aspect_ratio;
        } else {
          var ratioWidthHeight = '';
        }

        var ratioWidthHeightOther = boostPFSThemeConfig.custom.aspect_ratio_other;
        if (ratioWidthHeightOther == '' && ratioWidthHeight == '') {
          return null;
        } else {
          if (aspect_ratio != 'other') {
            ratioWidthHeight = ratioWidthHeight.split(':');
            ratioWidthHeight = parseInt(ratioWidthHeight[1]) / parseInt(ratioWidthHeight[0]);
            heightImage = widthImage * ratioWidthHeight;
          } else if (ratioWidthHeightOther != '' && aspect_ratio == 'other') {
            ratioWidthHeightOther = ratioWidthHeightOther.split(':');
            ratioWidthHeightOther = parseInt(ratioWidthHeightOther[1]) / parseInt(ratioWidthHeightOther[0]);
            heightImage = widthImage * ratioWidthHeightOther;
          }
        }
        jQ('.boost-pfs-filter-product-item-image-link').css({ 'padding-top': heightImage + 'px' }).addClass('boost-pfs-filter-crop-image-position-' + cropImagePosition);

      }
    }
  }

  // Swap Image
  function swapImage(data) {
    if (!Utils.isMobile()) {
      if (boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
        boostPFSThemeConfig.custom.active_image_swap == true) {
        var dataSrcSetFlipImg = '',
          dataSrcFlipImg = '',
          flipImageAlt = '',
          dataSizes = 'auto',
          dataWidths = '',
          html = '';

        jQ(".boost-pfs-filter-product-item").each(function() {
          var productItemSelector = jQ(this);
          var imgSelector = productItemSelector.find('.boost-pfs-filter-product-item-main-image');

          if (typeof imgSelector.data('img-flip-src') != 'undefined' &&
            imgSelector.data('img-flip-src') != '') {
            dataSrcFlipImg = imgSelector.data('img-flip-src');
            dataSrcSetFlipImg = imgSelector.data('img-flip-srcset');
            flipImageAlt = imgSelector.attr('alt');
            dataWidths = imgSelector.data('widths');
            html = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
              'data-srcset="' + dataSrcSetFlipImg + '" ' +
              'data-src="' + dataSrcFlipImg + '" ' +
              'data-widths="[' + dataWidths + ']" ' +
              'data-sizes="' + dataSizes + '" ' +
              'src="' + boostPFSImgDefaultSrc + '" ' +
              'alt="' + flipImageAlt + '" />';

            productItemSelector.find('.boost-pfs-filter-product-item-image-link').append(html);
          }

        });
      }
    }
  }

  // Build Placeholder for the first load
  function boostRemoveImageLoadingAnimation($selector) {
    if ($selector.length) {
      $selector.removeAttr('data-boost-image-loading-animation');
    }
  }
  /* Expand Filter */
  jQ(document).ready(function() {
      jQ('.boost-pfs-filter-custom-filter-button').on('click', function(){
          jQ('body').toggleClass('boost-pfs-filter-custom-drawer-open');
      });
      jQ('.boost-pfs-filter-custom-drawer-close').click(function(){
          jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
      });
      jQ('.boost-pfs-filter-custom-drawer-overlay').click(function(){
          jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
      });
  });

  /* Sticky Filter Mobile */
  function stickyFilterMobile() {
    var windowTop = window.pageYOffset || document.body.scrollTop;
    var heightFooter = 0;
    var divTop = 0;
    var divHeight = 0;
    if(jQ("#shopify-section-footer").length > 0){
      heightFooter = jQ("#shopify-section-footer").height();
    }
    if(jQ(".boost-pfs-filter-wrapper").length > 0){
      divTop = jQ('.boost-pfs-filter-wrapper').offset().top;
    }
    if(jQ(".boost-pfs-filter-wrapper").length > 0){
      divHeight = jQ(".boost-pfs-filter-wrapper").height();
    }

    if (windowTop > divTop + divHeight - heightFooter){
        jQ('body').removeClass('boost-pfs-mobile-stick');
    } else if (windowTop > divTop) {
        jQ('body').addClass('boost-pfs-mobile-stick');
    } else {
        jQ('body').removeClass('boost-pfs-mobile-stick');
    }
  }

  /* Sticky Filter Desktop Horizontal */
  function stickyFilterHorizontal() {
    if(jQ('.boost-pfs-filter-tree-h-sticky-filter').length > 0 && !Utils.isMobile()){
      var windowTop = window.pageYOffset || document.body.scrollTop;
      var divTop = 0;
      if(jQ('.boost-pfs-filter-wrapper').length > 0){
        divTop = jQ('.boost-pfs-filter-wrapper').offset().top;
      }
          
      if (windowTop > divTop) {
        jQ('body').addClass('boost-pfs-filter-horizontal-sticky-body');
      } else {
        jQ('body').removeClass('boost-pfs-filter-horizontal-sticky-body');
      }
    }
  }
    
})();
$(window).on('resize scroll load', function() {
  $('.productGrid .boost-pfs-filter-product-item').each(function() {
    if ($(this).isInViewport()) {
      var swatchElem = $(this).find('.boost-pfs-filter-item-swatch li span.selected');
      pfsSwatchClick(swatchElem, true, 'all grid trigger', $(this).find('.overlayLink').attr('aria-label'))
    } else {
        // do something else
    }
  });
});
$(document).ready(function() {
  


  // check for size filter and add url mapping
  if (colFilterQuery.sizes != undefined) {
      var filterSizesMapArr = boostPFSThemeConfig.custom.filterSizesMap.split(', ');
      $.each(filterSizesMapArr, function( key, value ) {
        if (value.indexOf(colFilterQuery.sizes) > -1) {
            sizeHandle = '-'+value.split(': ')[1];
        }
    });
  }
  var defaultSRC = boostPFSFilterConfig.boostPFSImgDefaultSrc;
  var defaultPFSSizes = boostPFSFilterConfig.boostPFSSizes;
var clickCount = 0;
  $('body').on('click mouseover', '.boost-pfs-filter-item-swatch li span', function() {
    
    //console.log('sizeHandleHover:'+sizeHandle);

    

    //console.log('swatch click', clickCount);
    clickCount += 1;
    pfsSwatchClick($(this), false, 'swatch click '+clickCount);

    //console.log('pfsSwatchClick3 click event');

    

  });// end mouseover

  if (colFilterQuery.sizes != undefined) {
    // show hide size in hto  
    var sizeParamArr = colFilterQuery.sizes.split(',');
    $('.htoSize label').addClass('unAvailable');
    $.each(sizeParamArr, function(index, paramSize) {
      var sizeText = paramSize.replace('Sizes_', '').split(' [')[0];
      $('.htoSize label[data-size="'+sizeText+'"]').removeClass('unAvailable'); 
    });    
  }



  
  
  $('body').on('click', '.toggleFilter', function() {
      $('body').toggleClass('filterOpen');
      $('.boost-pfs-filter-left-col').toggleClass('exp');
      $('.boost-pfs-filter-left-col-inner').scrollTop(0); 
  });
  $('body').on('click', '.closeFilter', function() {
      $('body').removeClass('filterOpen');
      $('.boost-pfs-filter-left-col').removeClass('exp');
  });
  $('body').on('click', '.filterAction a', function() {
     $('body').removeClass('filterOpen');
      $('.boost-pfs-filter-left-col').removeClass('exp');
  });
});

var pfsResizeTimer;

$(window).on('resize', function(e) {
  if ($('body').hasClass('pfs-rendered')) {
      clearTimeout(pfsResizeTimer);
      pfsResizeTimer = setTimeout(function() {
        gridMarketing();  
      }, 300);
    }
});


function gridMarketing() {
  /*
  var winWidth = window.innerWidth;
  var ppp = boostPFSThemeConfig.custom.products_per_row;
  // set product per row
  if (winWidth > 991) {
      //console.log('desktop');
      ppp = boostPFSThemeConfig.custom.products_per_row;
  } else if (winWidth > 749) {
      //console.log('tablet');
      ppp = boostPFSThemeConfig.custom.products_per_row_t;
  } else if (winWidth > 411) {
      //console.log('mobile wide');
      ppp = boostPFSThemeConfig.custom.products_per_row_mw;
  } else {
      //console.log('mobile');
      ppp = boostPFSThemeConfig.custom.products_per_row_m;
  }

  $('.gridMarketing').remove();
  $.each(boostPFSThemeConfig.custom.grid_marketing, function(index, gridMarketing) {
      var itemIndex = ((gridMarketing.row * ppp) - 1) - ppp;
      var gridMarkElem = $('.productGrid .boost-pfs-filter-product-item-grid[data-page="1"]:eq(' + itemIndex + ')');
      // if collection blank show on all collection
      if (gridMarketing.collection == '') {
          gridMarkElem.after('<div class="gridMarketing"><div class="gridMarketingCont">' + gridMarketing.content + '</div></div>');
      } else {
        // filter based on collection
        var gridCollectionArr = gridMarketing.collection.split(', ');
        $.each(gridCollectionArr, function(index, collectionMarketing) {
        if (boostPFSThemeConfig.custom.collection_handle == collectionMarketing) {
            gridMarkElem.after('<div class="gridMarketing"><div class="gridMarketingCont">' + gridMarketing.content + '</div></div>');
          }  
      }); 
      }
  });
  */
  if (typeof grid_marketing !== 'undefined') {
    
    var parentWidth = $('.boost-pfs-filter-products').outerWidth();
    var childWidth = $('.boost-pfs-filter-product-item').outerWidth();
    var prodPerRow = Math.round(parentWidth / childWidth);
    var prodCount = $('.boost-pfs-filter-product-item').length - 1;


    $('.gridMarketing').remove();
    $.each(grid_marketing, function(index, gridMarketing) {
        if (gridMarketing.type == 'custom-grid') {
            //console.log('custom-grid');


            var mRow = gridMarketing.row;
            var mCol = gridMarketing.column;
            if (mCol > prodPerRow) {
              mCol = prodPerRow;
            }

            var itemIndex = ((mRow * prodPerRow) - 1) - prodPerRow;
            var itemIndex =  itemIndex + (mCol - 1);    
            
            if (prodCount > itemIndex) {
              var gridMarkElem = $('.productGrid .boost-pfs-filter-product-item-grid[data-page="1"]:eq(' + itemIndex + ')'); 
              var gridImg = gridMarketing.image;
              var gridContent = '<div class="marketingBox"><div class="marketingCont">'+gridMarketing.content+'</div>'+gridImg+'</div>';

              gridMarkElem.after('<div class="gridMarketing customCard boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-t-2 boost-pfs-filter-grid-width-mb-1" data-page="1">'+gridContent+'</div>');
            }
        } else if (gridMarketing.type == 'text-block') {
            
            var itemIndex = ((gridMarketing.row * prodPerRow) - 1) - prodPerRow;
            var gridMarkElem = $('.productGrid .customCard[data-page="1"]:eq(' + itemIndex + ')');

            //console.log('text-block', itemIndex);

            // if collection blank show on all collection       
            gridMarkElem.after('<div class="gridMarketing"><div class="gridMarketingCont">' + gridMarketing.content + '</div></div>');
        }  
    });

    // $('.productGrid .boost-pfs-filter-grid-width-3').matchHeight({
    //   //  property: 'min-height' 
    // });




  }   
}

function slugify(str) {
  return String(str)
    .normalize('NFKD') // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-'); // remove consecutive hyphens
}

function pfsSwatchClick(elem, triggerFlag, param) {
  var $this = elem;
  var runFlag = true;
  var pCard = $this.closest('.boost-pfs-filter-product-item-inner');
  if (triggerFlag) {
    if (pCard.hasClass('clicked')) {
      return false;
    } else {
      pCard.addClass('clicked')
    }
  }

  var overlayLink = $this.closest('.product-card').find('.overlayLink');
  var originalHref = overlayLink.attr('data-href');
  var colorhandle = $this.attr('data-handle');

  var pHandle = pCard.find('.htoOverlayBox').attr('data-handle');
  var variantJSON = JSON.parse(pCard.find('.variantJson').html());
  var colorValue = $this.attr('aria-label');
  var hasSizeOption = variantJSON[0].option_size;
  var imgElem = pCard.find('.boost-pfs-filter-product-item-main-image');
  var imgElemBox = imgElem.parent();
  var imgSwatch = $this.attr('data-img');
  var pc2obFlag = $this.closest('.customCard').attr('data-pc02b-flag');

  var sizeHandleEntry = sizeHandle;
  var oosFlag = $this.closest('li').hasClass('unavailable');
  if (oosFlag == true) {
    pCard.addClass('oos');
  } else {
    pCard.removeClass('oos');
  }


  if (pc2obFlag == 'true') {
    sizeHandleEntry = '';
  }

  var defaultSRC = boostPFSFilterConfig.boostPFSImgDefaultSrc;
  var defaultPFSSizes = boostPFSFilterConfig.boostPFSSizes;

  /*
  imgElem.attr('srcset', imgSwatch).attr('sizes', defaultPFSSizes);
  if (imgSwatch.indexOf(',') > -1) {
    var sizeW = '_' + imgSwatch.split(', ')[1].split(' ')[1].replace('w', 'x');
    var origSrc = imgSwatch.split(', ')[1].split(' ')[0].replace(sizeW, '');
    console.log(origSrc);
    imgElem.attr('data-src', origSrc);
  }
  */

  $this.closest('.product-card').find('.closeHTO').trigger('click');
  pCard.addClass('clicked');


  
  colFilterQuery = getQueryParams(document.location.search);
  var addedUrlArr = [];
  var addedUrl = '';

  if (colFilterQuery.eye_size != undefined) {
    addedUrlArr.push('eye_size=' + slugify(colFilterQuery.eye_size.toLowerCase().split(',').pop().replace('eye size_', '').replace(/[^A-Z0-9]+/ig, "-")));
  }
  if (colFilterQuery.width != undefined) {
    addedUrlArr.push('width=' + slugify(colFilterQuery.width.toLowerCase().split(',').pop().replace('width_', '').replace(/[^A-Z0-9]+/ig, "-")));
  }

  addedUrlArr.push('color=' + colorhandle);
  // set url
  $.each(addedUrlArr, function(index, urlItem) {
    if (index == 0) {
      addedUrl = '?' + urlItem;
    } else {
      addedUrl += '&' + urlItem
    }
  });

  var globalAddedUrl2 = '';
  if (theme.custom.collectionTitle != undefined) {
    globalAddedUrl2 += '&atcsource=cp'
  }

  var adjustedURL = originalHref.split('?')[0] + sizeHandleEntry + addedUrl + globalAddedUrl2;
  //console.log('adjustedURL:'+adjustedURL)

  overlayLink.attr('href', adjustedURL);
  $this.closest('ul').find('li span').removeClass('selected');
  $this.addClass('selected');

  
  // change hto size id based on color selection
  //console.log(variantJSON)
  var sizeAvailCount = 0;
  pCard.find('.htoSize label').each(function() {
    //var pSize = $(this); 
    var pSize = $(this);
    var htoSizeVal = pSize.attr('data-size');
    var eyeSizeVal = pSize.attr('data-eye-size');
    pSize.addClass('soldOut');
    pSize.not('[data-type="pc02b"]').not('[data-size="default"]').addClass('unAvailable');
    //console.log('eyeSizeVal:'+eyeSizeVal);
    $.each(variantJSON, function(index, variantItem) {
      if (hasSizeOption != undefined) {



        //console.log('htoSizeVal:'+htoSizeVal);
        //console.log('colorValue:'+colorValue); 

        if (eyeSizeVal != undefined) {
          var variantTitle = variantItem.title;
          var variantInteger = variantTitle.match(/(\d+)/);
          var variantSize = '';
          if (variantInteger) {
            variantSize = variantInteger[0];
          }

          if (eyeSizeVal == variantSize && variantTitle.indexOf(colorValue) > -1) {
            //console.log('variantSize:'+variantSize, variantItem.sku);
            // console.log('colorValue:'+colorValue); 
            // console.log(variantItem);
            pSize.find('input').val(variantItem.id);
            pSize.attr('data-sku', variantItem.sku);

            if (variantItem.available == true) {
              pSize.removeClass('soldOut');
              sizeAvailCount += 1;
            }
            pSize.removeClass('unAvailable');
            return false;
          }


        } else {
          if (variantItem.title.indexOf(htoSizeVal + ' / ' + colorValue) > -1 || variantItem.title.indexOf(colorValue + ' / ' + htoSizeVal) > -1) {
            pSize.attr('data-sku', variantItem.sku);
            pSize.find('input').val(variantItem.id);
            if (variantItem.available == true) {
              pSize.removeClass('soldOut');
              sizeAvailCount += 1;
            }
            pSize.removeClass('unAvailable');
            return false;
          }
        }



      } else {
        if (variantItem.title.indexOf(colorValue) > -1) {
          pSize.find('input').val(variantItem.id);
          if (variantItem.available == true) {
            pSize.removeClass('soldOut');
            sizeAvailCount += 1;
          }
          return false;
        }
      }
    });
    if (colFilterQuery.sizes != undefined) {
      // show hide size in hto  
      var sizeParamArr = colFilterQuery.sizes.split(',');
      pCard.find('.htoSize label').addClass('unAvailable');
      $.each(sizeParamArr, function(index, paramSize) {
        var sizeText = paramSize.replace('Sizes_', '').split(' [')[0].replace('Kids', 'Youth');
        pCard.find('.htoSize label[data-size="' + sizeText + '"]').removeClass('unAvailable');
      });
    }
    // disable hto function
    checkHTOGrid(pCard, pHandle, colorValue);


  }); // end pCard.find('.htoSize label').each(function() {
  //disable if no available size

  if (pCard.find('.htoSize').html() == '') {
    pCard.find('.htoOverlayBox').attr('status', 'disabled');
  } else {
    pCard.find('.htoOverlayBox').attr('status', 'empty');
  }

  if ($('body').hasClass('pfs-rendering') == false) {
    requestIdleCallback(() => {
      checkHTOItem();
    });

  }
  
  //console.log('pfsSwatchClick', pHandle, triggerFlag, param);
  return false;


}